import { combineReducers } from 'redux'
import {
  CHANGE_FILTER,
  CHANGE_SORT,
  CHANGE_PAGE,
  CHANGE_HIDE_COMPLETED,
  CHANGE_VENDOR,
  FETCH_TRANSCRIPTION_TRANSCRIPT_REQUESTS_REQUEST,
  FETCH_TRANSCRIPTION_TRANSCRIPT_REQUESTS_SUCCEEDED,
  FETCH_TRANSCRIPTION_TRANSCRIPT_REQUESTS_FAILED,
  RETRY_TRANSCRIPT_REQUEST_REQUEST,
  RETRY_TRANSCRIPT_REQUEST_SUCCEEDED,
  RETRY_TRANSCRIPT_REQUEST_FAILED
} from '../actions/transcriptionTranscriptRequestActions'

const TOTAL_PAGES = /page\[number]=(\d+)/i

const pageFromUrl = url => {
  const decodedUrl = decodeURI(url)
  const results = TOTAL_PAGES.exec(decodedUrl) || []
  return parseInt(results[1] || 1, 10)
}

const normalizeId = id => parseInt(id, 10)

const loading = (state = false, action) => {
  switch (action.type) {
    case FETCH_TRANSCRIPTION_TRANSCRIPT_REQUESTS_REQUEST:
    case RETRY_TRANSCRIPT_REQUEST_REQUEST:
      return true
    case FETCH_TRANSCRIPTION_TRANSCRIPT_REQUESTS_SUCCEEDED:
    case FETCH_TRANSCRIPTION_TRANSCRIPT_REQUESTS_FAILED:
    case RETRY_TRANSCRIPT_REQUEST_SUCCEEDED:
    case RETRY_TRANSCRIPT_REQUEST_FAILED:
      return false
    default:
      return state
  }
}

const byId = (state = {}, action) => {
  switch (action.type) {
    case FETCH_TRANSCRIPTION_TRANSCRIPT_REQUESTS_SUCCEEDED:
      return action.data.data.reduce((memo, transcriptRequest) => {
        return {
          ...memo,
          [normalizeId(transcriptRequest.id)]: transcriptRequest
        }
      }, {})
    case RETRY_TRANSCRIPT_REQUEST_SUCCEEDED:
      return {
        ...state,
        [normalizeId(action.id)]: action.data.data
      }
    default:
      return state
  }
}

const ids = (state = [], action) => {
  switch (action.type) {
    case FETCH_TRANSCRIPTION_TRANSCRIPT_REQUESTS_SUCCEEDED:
      return action.data.data.map(transcriptRequest =>
        normalizeId(transcriptRequest.id)
      )
    default:
      return state
  }
}

const filter = (state = null, action) => {
  switch (action.type) {
    case CHANGE_FILTER:
      return action.filter === '' ? null : action.filter
    default:
      return state
  }
}

const vendor = (state = null, action) => {
  switch (action.type) {
    case CHANGE_VENDOR:
      return action.vendor === '' ? null : action.vendor
    default:
      return state
  }
}

const totalPages = (state = 1, action) => {
  switch (action.type) {
    case FETCH_TRANSCRIPTION_TRANSCRIPT_REQUESTS_SUCCEEDED:
      return pageFromUrl(action.data.links.last)
    default:
      return state
  }
}

const page = (state = 1, action) => {
  switch (action.type) {
    case CHANGE_PAGE:
      return action.page
    case CHANGE_FILTER:
      return 1
    default:
      return state
  }
}

const sort = (state = 'id', action) => {
  switch (action.type) {
    case CHANGE_SORT:
      return action.sort
    case CHANGE_FILTER:
      return 'id'
    default:
      return state
  }
}

const order = (state = 'desc', action) => {
  switch (action.type) {
    case CHANGE_SORT:
      return action.order
    case CHANGE_FILTER:
      return 'desc'
    default:
      return state
  }
}

const hideCompleted = (state = false, action) => {
  if (action.type === CHANGE_HIDE_COMPLETED) {
    return action.hideCompleted
  }
  return state
}

export default combineReducers({
  byId,
  ids,
  filter,
  page,
  loading,
  order,
  sort,
  totalPages,
  hideCompleted,
  vendor
})

export const selectTranscriptRequests = state =>
  state.ids.map(id => state.byId[id])

export const selectLoading = state => state.loading
export const selectPage = state => state.page
export const selectTotalPages = state => state.totalPages
export const selectSort = state => state.sort
export const selectOrder = state => state.order
export const selectFilter = state => state.filter
export const selectHideCompleted = state => state.hideCompleted
export const selectVendor = state => state.vendor



// WEBPACK FOOTER //
// ../src/reducers/transcriptionTranscriptRequests.js